import { Typography } from '@design-system';
import { NewsTag } from '@services/news/news.types';
import './Tag.scss';

type TagProps = NewsTag;

export const Tag: React.FC<TagProps> = ({ title, color }) => {
    return (
        <div className="tag" style={{ backgroundColor: color }}>
            <Typography intrinsic="p">{title}</Typography>
        </div>
    );
};
